import apiClient from "services/apiClient";

async function getReportColumns(reportId: any) {
  const res = await apiClient.get(`/admin/reports/${reportId}/columns`);
  return res.data;
}

export default getReportColumns;
